import React from "react";
import useContactList from "./useContactList";
import CardGrid from "../../../components/ContactCardGrid";
import SiteHeader from "../../../stories/Components/SiteHeader/SiteHeader";
import PrimaryButton from "../../../stories/Components/Buttons/PrimaryButton";
import Table from "../../../stories/Components/Table/Table";
import ImportContactsModal from "../../../stories/Components/ContactView/ImportContactsModal";
import { SHOW_COLUMNS_SETTING_RIGHT } from "../../../constants";
import TableActionsIconsGroup from "../../../stories/Components/Table/TableActionsIconsGroup";

const ContactList = () => {
  const {
    currentUser,
    selectedRows,
    resourcePersistedView,
    isFetching,
    showImportModal,
    setShowImportModal,
    onImport,
    handleRowSelect,
    handleRemoveUser,
    onContactClick,
    buttonActions,
    contacts,
    columns,
    canDeleteUsers,
    allowSelection,
    templateSettings,
  } = useContactList();

  const isListView = resourcePersistedView === "list";
  const isCardView = resourcePersistedView === "card" || !resourcePersistedView;

  return (
    <>
      <SiteHeader
        title="Contacts"
        buttons={
          <PrimaryButton
            large
            title="Actions"
            className="dropdown-btn"
            dropdownItems={buttonActions}
          />
        }
      />
      <div
        style={{
          borderRadius: "10px",
          height: "1098px", // figma specific
        }}
        className={`${
          isFetching && "loading relative"
        } border border-es-light-grey shadow-lg p-8 w-full justify-between bg-es-white`}
      >
        <Table
          showConstantRowIndex
          disableCreateTemplate
          templateSettings={templateSettings}
          showScrollShadow
          pagination={isListView && 20}
          isLoading={isFetching}
          resourceName="contacts"
          data={contacts}
          columns={columns}
          onRowClick={(row) => onContactClick(row.id)}
          allowSelection={allowSelection}
          onSelectedRowChange={handleRowSelect}
          onDeleteRowClick={handleRemoveUser}
          fileActionsIcons={
            <TableActionsIconsGroup
              style={{ height: "100%" }}
              handleShowDelete={handleRemoveUser}
              canDelete={isListView && canDeleteUsers}
              disabled={selectedRows?.length === 0}
              selectedRows={selectedRows}
              showColumnSettingsRight={SHOW_COLUMNS_SETTING_RIGHT && isListView}
              disabledColumnSettings={isCardView}
            />
          }
          cardGrid={isCardView}
          cardGridComponent={(row) => (
            <CardGrid
              currentUser={currentUser}
              row={row}
              onContactClick={onContactClick}
            />
          )}
          showColumnSettingsLeft={!SHOW_COLUMNS_SETTING_RIGHT}
        />
      </div>
      {showImportModal && (
        <ImportContactsModal
          onClose={() => setShowImportModal(false)}
          onCSVUpload={onImport}
        />
      )}
    </>
  );
};

export default ContactList;
